'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Record = undefined;

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Record = exports.Record = undefined;

exports.Record = Record = function Record(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};

    // constructor
    t.id = config.id;
    t.name = config.name;

    // tmp 2.22
    t.objectName = config.objectName;

    if ((0, _isString2.default)(config.dimensionItemType)) {
        t.dimensionItemType = config.dimensionItemType;
    }
};

Record.prototype.log = function (text, noError) {
    if (!noError) {
        console.log(text, this);
    }
};

Record.prototype.val = function (noError) {
    if (!this || !(0, _isString2.default)(this.id)) {
        this.log('(Record) Id is not a string', noError);
        return null;
    }

    return this;
};

Record.prototype.setName = function (name, response) {
    this.name = name || this.name || (this.id && response ? response.getNameById(this.id) : null);
};

Record.prototype.toPlugin = function () {
    delete this.klass;
};

Record.prototype.toPost = function () {
    delete this.klass;
    delete this.name;
    delete this.dimensionItemType;
};
//# sourceMappingURL=Record.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Record.js
 ** module id = 123
 ** module chunks = 0 1
 **/